import { render, staticRenderFns } from "./DealOrganizationInfo.vue?vue&type=template&id=071cee83&"
import script from "./DealOrganizationInfo.vue?vue&type=script&lang=js&"
export * from "./DealOrganizationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports